import { encode } from 'html-entities';
import { type ExportCell, type ExportColumns } from '../types';
import { downloadBlob, formatCellValue } from '../utils';
import { UTF8_BYTE_ORDER_MARK } from '../constants';

const buildXls = (columns: ExportColumns[], rows: ExportCell[][], formatDate?: (date: Date) => string) => {
  const header = `<tr>${columns.map((column) => `<th>${encode(column.label)}</th>`).join('')}</tr>`;
  const body = rows
    .map((row) => `<tr>${row.map((cell) => `<td>${encode(formatCellValue(cell, formatDate))}</td>`).join('')}</tr>`)
    .join('');

  return `${UTF8_BYTE_ORDER_MARK}<html><head><meta charset="utf-8" /></head><body><table>${header}${body}</table></body></html>`;
};

export const exportXls = (options: {
  columns: ExportColumns[];
  rows: ExportCell[][];
  formatDate?: (date: Date) => string;
  fileName: string;
}) => {
  const xls = buildXls(options.columns, options.rows, options.formatDate);
  const blob = new Blob([xls], { type: 'application/vnd.ms-excel;charset=utf-8;' });

  downloadBlob(blob, `${options.fileName}.xls`);
};
